import { BASE_MOBILE_API_URL, BASIC_AUTH, formatMonthDate } from "../constants";
import { useNavigate, useOutletContext } from "react-router-dom";
import { notifyError, notifySuccess } from "../components/notify";
import React, { useCallback, useRef } from "react";
import { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import ExpandableTextMobile from "../components/ExpandableText";
import OrderList from "./Order_List";
import axios from "axios";
import TableLoader from "../components/Spinner/TableLoader";
import ButtonSpinner from "../components/Spinner/ButtonSpinner";

const NewOrder = () => {
  const navigate = useNavigate();
  const currentDate = new Date();
  const { setPageTitle } = useOutletContext();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setPageTitle("Order List");
  }, [setPageTitle]);

  const [ordersData, setOrderData] = useState({
    order_header: [],
    order_details: [],
    order_payment_trsc: [],
  });

  const [filteredOrders, setFilteredOrders] = useState({
    order_header: [],
    order_details: [],
    order_payment_trsc: [],
  });

  const [itemsList, setItemList] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [createOrderModal, setCreateOrderModal] = useState(false);
  const [showConfirmationModal, setShowConfimationModal] = useState(false);
  const [cancelConfirmationModal, setCancelConfimationModal] = useState(false);

  const [selectedItem, setSelectedItem] = useState(null);
  const [pcs, setPcs] = useState("1");
  const [qty, setQty] = useState("");
  const [rate, setRate] = useState("");
  const [remark, setRemark] = useState("");
  const [showItemModal, setShowItemModal] = useState(false);
  const [rateMeta, setRateMeta] = useState(null);

  const [status, setStatus] = useState("A");

  const [addLoading, setAddLoading] = useState(false);

  const itemRef = useRef();
  const pcsRef = useRef();
  const qtyref = useRef();

  const [orderItems, setOrderItems] = useState([]);
  const [showTable, setShowTable] = useState(false);
  // const billNo = "BILL-002"; // dynamic if needed

  const [showDeliveryTypeModal, setShowDeliveryTypeModal] = useState(false);
  const [deliveryType, setDeliveryType] = useState("S");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const [searchText, setSearchText] = useState("");

  const customerStr = localStorage.getItem("customerInfo");
  const customer = customerStr ? JSON.parse(customerStr) : null;

  const filteredItems = itemsList.filter((item) =>
    item.name?.toLowerCase().startsWith(searchText.toLowerCase()),
  );

  const itemMaster = React.useMemo(() => {
    const stored = localStorage.getItem("itemMaster");
    return stored ? JSON.parse(stored) : [];
  }, []);

  const itemMap = React.useMemo(() => {
    const map = {};
    itemMaster.forEach((item) => {
      map[item.itemcode] = item.name;
    });
    return map;
  }, [itemMaster]);

  useEffect(() => {
    if (createOrderModal) {
      itemRef.current?.focus();
    }
  }, [createOrderModal]);

  const applyStatusFilter = (data, statusValue, currentDate) => {
    let filteredHeaders = data.order_header;

    // STATUS FILTER
    if (statusValue === "A") {
      filteredHeaders = filteredHeaders.filter(
        (item) => item.status === "Y" || item.status === "O",
      );
    } else {
      filteredHeaders = filteredHeaders.filter(
        (item) => item.status === statusValue,
      );
    }

    setFilteredOrders({
      ...data,
      order_header: filteredHeaders,
    });
  };

  const handleProceed = useCallback(async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${BASE_MOBILE_API_URL}/get_customer_orderv1`,
        {
          params: {
            companycode: customer?.companycode,
            supervisorcode: customer?.customercode,
            branchcode: customer?.branchcode,
            fromdate: currentDate,
            todate: currentDate,
            orderflag: "O",
            callfrom: "C",
            qr_code_token_val: "0",
          },
          headers: {
            Authorization: BASIC_AUTH,
          },
        },
      );

      const result = response.data;
      setOrderData(result);
      applyStatusFilter(result, status, currentDate);
    } catch (err) {
      if (err.response) {
        // Server responded with error status
        // const errorMessage =
        //   err.response?.data && typeof err.response.data === "string"
        //     ? err.response.data
        //     : err.response?.data?.message ||
        //       err.response?.data?.error ||
        //       "Login failed";

        // notifyError(errorMessage);
        setFilteredOrders({
          order_header: [],
          order_details: [],
          order_payment_trsc: [],
        });
      }
    } finally {
      setLoading(false);
    }
  }, [customer, currentDate]);

  const hasFetched = useRef(false);

  useEffect(() => {
    if (hasFetched.current) return;
    if (currentDate) {
      hasFetched.current = true;
      handleProceed();
    }
  }, [handleProceed, currentDate]);

  const getItemList = useCallback(async () => {
    try {
      const response = await axios.get(
        `${BASE_MOBILE_API_URL}/get_item_master`,
        {
          params: {
            companycode: customer?.companycode,
            supervisorcode: customer?.customercode,
            branchcode: customer?.branchcode,
          },
          headers: {
            Authorization: BASIC_AUTH,
          },
        },
      );

      const result = response.data;
      setItemList(result);
    } catch (err) {
      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.data?.error ||
              "Fatch Item list failed";

        notifyError(errorMessage);
      } else if (err.request) {
        // No response received
        notifyError("Server not responding. Please try again.");
      } else {
        // Other errors
        notifyError("Something went wrong.");
      }
    }
  }, [customer]);

  const hasFetchedItem = useRef(false);

  useEffect(() => {
    if (hasFetchedItem.current) return;
    if (createOrderModal) {
      hasFetchedItem.current = true;
      getItemList();
    }
  }, [getItemList, createOrderModal]);
  // useEffect(() => {
  //   if (createOrderModal) {
  //     getItemList();
  //   }
  // }, [getItemList, createOrderModal]);

  const handleAddItem = () => {
    // Item validation
    if (!selectedItem) {
      if (itemRef.current) itemRef.current.focus();
      // setItemError("Please select an item.");
      notifyError("Please select an item.");
      return;
    }

    // Pcs validation
    if (!pcs || Number(pcs) <= 0) {
      if (pcsRef.current) pcsRef.current.focus();
      // setPcsError("Please enter a valid number of pcs.");
      notifyError("Please enter a valid number of pcs.");
      return;
    }

    // Qty validation
    if (!qty || Number(qty) <= 0) {
      if (qtyref.current) qtyref.current.focus();
      // setQtyError("Please enter a valid quantity.");
      notifyError("Please enter a valid quantity.");
      return;
    }

    const newItem = {
      companycode: customer.companycode,
      branchcode: customer.branchcode,

      itemcode: selectedItem.itemcode,
      itemname: selectedItem.name,

      rate: Number(rate) || 0,
      noofitem: Number(pcs),
      qty: Number(qty),
      amount: Number(qty) * Number(rate || 0),
    };

    const updatedItems = [...orderItems, newItem];

    setOrderItems(updatedItems);
    localStorage.setItem("orderItems", JSON.stringify(updatedItems));

    setShowTable(true);

    // Clear inputs
    setSelectedItem(null);
    setPcs("1");
    setQty("");
    setRate("");
  };

  useEffect(() => {
    const saved = localStorage.getItem("orderItems");
    if (saved) {
      setOrderItems(JSON.parse(saved));
    }
  }, [showTable]);

  useEffect(() => {
    const saved = localStorage.getItem("orderItems");
    if (saved) {
      setOrderItems(JSON.parse(saved));
    }
  }, []);

  const totalPcs = selectedOrder?.details?.reduce(
    (sum, item) => sum + Number(item.noofitem),
    0,
  );

  const totalQty = selectedOrder?.details?.reduce(
    (sum, item) => sum + Number(item.qty),
    0,
  );

  const totalAmountDetails = selectedOrder?.details?.reduce(
    (sum, item) => sum + Number(item.amount),
    0,
  );

  const totalAmount = orderItems.reduce((sum, item) => sum + item.amount, 0);

  const resetCreateOrder = () => {
    setSelectedItem(null);
    setPcs("1");
    setQty("");
    setRate("");
    setRemark("");
    setDeliveryType("S");
    setOrderItems([]);
    localStorage.removeItem("orderItems");
    setShowTable(false);
  };

  const handleDeleteItem = () => {
    if (!selectedDeleteItem) return;

    const updatedItems = orderItems.filter(
      (item) => item.itemcode !== selectedDeleteItem.itemcode,
    );

    setOrderItems(updatedItems);
    localStorage.setItem("orderItems", JSON.stringify(updatedItems));

    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
  };

  const getItemRateData = (item) => {
    const customerRates =
      JSON.parse(localStorage.getItem("customerItemRateMaster")) || [];

    const branchRates =
      JSON.parse(localStorage.getItem("branchItemRateMaster")) || [];

    //  Customer Rate (highest priority)
    const customerRate = customerRates.find(
      (r) =>
        Number(r.itemcode) === Number(item.itemcode) &&
        Number(r.customercode) === Number(customer?.customercode),
    );

    if (customerRate) {
      return {
        source: "customer",
        rate: Number(customerRate.rate),
      };
    }

    //  Branch Rate
    const branchRate = branchRates.find(
      (r) => Number(r.itemcode) === Number(item.itemcode),
    );

    if (branchRate) {
      return {
        source: "branch",
        rate: Number(branchRate.rate),
        sp_rate: Number(branchRate.sp_rate),
        limitingweight: Number(branchRate.limitingweight),
      };
    }

    // Default item rate
    return {
      source: "default",
      rate: Number(item.rate) || 0,
    };
  };

  const headerData = {
    companycode: customer.companycode,
    branchcode: customer.branchcode,
    customercode: customer.customercode,
    ordername: `Order`,
    totalitem: orderItems.length,
    totalamount: totalAmount,
    remark: remark,
    orderfrom: "C",
    createdbyid: customer.customercode,
    customertype: customer.customertype,
    qr_token_code: "0",
    delivery_type: deliveryType,
    delivery_address_text: "",
    delivery_gps_location: "",
    delivery_pincode: "",
    delivery_time_slot: "",
    delivery_distance_val: "",
  };

  const finalData = {
    header: headerData,
    details: orderItems,
  };

  const handleCreateOrder = async () => {
    if (!finalData) return;
    setAddLoading(true);
    try {
      await axios.post(
        `${BASE_MOBILE_API_URL}/post_customer_order`,
        finalData,
        {
          headers: {
            Authorization: BASIC_AUTH,
          },
        },
      );

      setShowDeliveryTypeModal(false);
      notifySuccess("Order created successfully!");
      setCreateOrderModal(false);
      resetCreateOrder();
      handleProceed();
    } catch (err) {
      console.error(err);

      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.data?.error ||
              "Create order failed";

        notifyError(errorMessage);
      } else if (err.request) {
        // No response received
        notifyError("Server not responding. Please try again.");
      } else {
        // Other errors
        notifyError("Something went wrong.");
      }
    } finally {
      setAddLoading(false);
    }
  };

  const itemSearchRef = useRef(null);

  useEffect(() => {
    if (showItemModal) {
      itemSearchRef.current?.focus();
    }
  }, [showItemModal]);

  return (
    <>
      <div className="d-flex flex-column align-items-center">
        {filteredOrders && (
          <div className="col-12 col-md-6 col-lg-3 mt-2">
            <div className="d-flex align-items-center ">
              <label className="form-label text-white mb-0 text-nowrap col-3 col-lg-4">
                Status :
              </label>
              <select
                className="form-select flex-grow-1"
                value={status}
                onChange={(e) => {
                  const newStatus = e.target.value;
                  setStatus(newStatus);
                  applyStatusFilter(ordersData, newStatus, currentDate);
                }}
              >
                <option value="A">All</option>
                <option value="O">In-Process</option>
                <option value="Y">Pending</option>
              </select>
            </div>
          </div>
        )}
        {loading ? (
          <TableLoader
            message={`Loading order data...`}
            size="sm"
            messageClass="tablemessage-white py-3"
            spinnerClass="tablespinner-white"
          />
        ) : (
          <>
            <OrderList
              ordersData={filteredOrders}
              loading={loading}
              setSelectedOrder={setSelectedOrder}
              setShowModal={setShowModal}
              notifyError={notifyError}
              setCreateOrderModal={setCreateOrderModal}
              refreshOrders={handleProceed}
            />
          </>
        )}
      </div>

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="xl"
        centered
        backdrop="static"
        keyboard={false}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="fw-bold">Order Detail</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {selectedOrder && (
              <>
                {/* Order Info */}
                <div className="row mb-3 fw-bold">
                  <div className="col-12 d-block d-md-flex d-lg-flex justify-content-md-between justify-content-lg-between">
                    <div>Order No : {selectedOrder.header.ordercode}</div>
                    <div className="mb-1">
                      Date : {formatMonthDate(selectedOrder.header.entrydate)} |{" "}
                      {selectedOrder.header.entrytime}
                    </div>
                  </div>

                  <div className="col-md-12  d-flex  justify-content-end">
                    <div>
                      <span className="bg-white text-success px-2 py-1 mt-1 rounded">
                        Total Amount : {selectedOrder.header.totalamount}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Items Table */}
                <div className="table-container">
                  <div className="table-responsive">
                    <table className="table table-dark table-bordered table-striped table-sm">
                      <thead>
                        <tr>
                          <th className="text-center">Sr No.</th>
                          <th>Item</th>
                          <th className="text-center">Pcs</th>
                          <th className="text-center">Qty</th>
                          <th>Rate</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedOrder.details?.map((itm, i) => (
                          <tr key={i}>
                            <td className="text-center">{i + 1}</td>
                            <td>{itemMap[itm.itemcode] || ""}</td>
                            <td className="text-center">{itm.noofitem}</td>
                            <td className="text-center">{itm.qty}</td>
                            <td>{itm.rate}</td>
                            <td>{itm.amount}</td>
                          </tr>
                        ))}

                        <tr className="table-secondary fw-bold">
                          <td className="text-center">TOTAL</td>
                          <td></td>
                          <td className="text-center">{totalPcs}</td>
                          <td className="text-center">{totalQty}</td>
                          <td></td>
                          <td>{totalAmountDetails?.toFixed(2)}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </div>
      </Modal>
      <Modal
        show={createOrderModal}
        onHide={() => {
          resetCreateOrder();
          setCreateOrderModal(false);
        }}
        onEntered={() => resetCreateOrder()}
        backdrop="static"
        keyboard={false}
        size="lg"
        fullscreen="sm-down"
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">
              Create Customer Order
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* {customer && (
              <>
                <div className="company-selected-card mb-4 p-0 rounded-4 mx-lg-5  d-flex">
                  
                  <div className="company-logo-top  col-lg-2 col-3 mt-2  ">
                    <img
                      src={
                        customer?.profileimage || "/assest/user_profile.png"
                      }
                      alt="company logo"
                      className="p-0"
                    />
                  </div>

                  
                  <div className="company-details  col-lg-10 col-11 p-2 mt-lg-2">
                    <div className="d-block d-lg-flex ">
                      <div className="company-row col-lg-6 col-12 mb-0">
                        <span className="company-label"> Name :</span>
                        <ExpandableTextMobile
                          text={`${customer.name}`}
                          className="long-remark-text text-white"
                        />
                      </div>

                      <div className="company-row col-lg-6 col-12 mb-0">
                        <span className="company-label">Mobile :</span>
                        <span className="company-value">{customer.mobile}</span>
                      </div>
                    </div>
                    <div className="d-block d-lg-flex ">
                      <div className="company-row col-lg-6 col-12 mb-0">
                        <span className="company-label">Email :</span>
                        <span className="company-value">
                          <ExpandableTextMobile
                            text={`${customer.email}`}
                            className="long-text text-white"
                          />
                        </span>
                      </div>
                      <div className="company-row col-lg-6 col-12 mb-0">
                        <span className="company-label"> Address :</span>
                        <ExpandableTextMobile
                          text={customer.address}
                          className="medium-text  mb-1 text-white"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )} */}

            <div className=" order-input-card p-3 rounded-4 mt-3 ">
              {/*  Select Item */}
              <div className="mb-2 col-12">
                <label className="form-label">
                  Select Item <span className="red-error">*</span>
                </label>
                <input
                  ref={itemRef}
                  type="text"
                  className="form-select"
                  value={selectedItem?.name || ""}
                  placeholder="Click to select item"
                  readOnly
                  onClick={() => setShowItemModal(true)}
                />
                {/* {itemError && <p className="red-error">{itemError}</p>} */}
              </div>
              <div className="col-12 d-flex justify-content-between">
                {/*  Pcs */}
                <div className="mb-1 col-5">
                  <label className="form-label">
                    No of Pcs <span className="red-error">*</span>
                  </label>
                  <input
                    ref={pcsRef}
                    type="number"
                    className="form-control"
                    value={pcs}
                    onChange={(e) => setPcs(e.target.value)}
                    placeholder="Enter No of Pcs"
                    onKeyDown={(e) => {
                      // Block arrow keys
                      if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onKeyPress={(e) => {
                      const isNumberKey = (event) => {
                        return (
                          event.key === "Backspace" ||
                          event.key === "Tab" ||
                          event.key === "ArrowLeft" ||
                          event.key === "ArrowRight" ||
                          event.key === "." ||
                          (event.key >= "0" && event.key <= "9")
                        );
                      };

                      if (!isNumberKey(e)) {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => {
                      // Prevent scrolling to change the value
                      e.target.blur();
                    }}
                  />
                  {/* {pcsError && <p className="red-error">{pcsError}</p>} */}
                </div>

                {/*  Qty */}
                <div className="mb-1 col-5">
                  <label className="form-label">
                    Qty <span className="red-error">*</span>{" "}
                    <span className="text-theme fw-bold">
                      {selectedItem?.unit === "K"
                        ? "(Kg)"
                        : selectedItem?.unit === "P"
                          ? "(Pcs)"
                          : selectedItem?.unit === "L"
                            ? "(Ltr)"
                            : ""}
                    </span>
                  </label>
                  <input
                    ref={qtyref}
                    type="number"
                    className="form-control"
                    value={qty}
                    placeholder="Enter Qty"
                    onChange={(e) => {
                      const value = e.target.value;
                      setQty(value);

                      if (!rateMeta) return;

                      const numericQty = Number(value);

                      // Only apply special logic if source is branch
                      if (rateMeta.source === "branch") {
                        if (numericQty > rateMeta.limitingweight) {
                          setRate(rateMeta.sp_rate); // apply special rate
                        } else {
                          setRate(rateMeta.rate); // revert to normal branch rate
                        }
                      }
                    }}
                    onKeyDown={(e) => {
                      // Block arrow keys
                      if (["ArrowUp", "ArrowDown"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    onKeyPress={(e) => {
                      const isNumberKey = (event) => {
                        return (
                          event.key === "Backspace" ||
                          event.key === "Tab" ||
                          event.key === "ArrowLeft" ||
                          event.key === "ArrowRight" ||
                          event.key === "." ||
                          (event.key >= "0" && event.key <= "9")
                        );
                      };

                      if (!isNumberKey(e)) {
                        e.preventDefault();
                      }
                    }}
                    onWheel={(e) => {
                      // Prevent scrolling to change the value
                      e.target.blur();
                    }}
                  />
                  {/* {qtyError && <p className="red-error">{qtyError}</p>} */}
                </div>
              </div>
              <div className="col-12 d-flex justify-content-between">
                {/*  Rate */}
                <div className="mb-1 col-5">
                  <label className="form-label">Rate</label>
                  <input
                    type="number"
                    className="form-control readonly-input"
                    value={rate ? Number(rate).toFixed(2) : ""}
                    onChange={(e) => setRate(selectedItem?.rate)}
                    readOnly
                  />
                </div>

                {/*  Amount (Auto Calculate) */}
                <div className="mb-1 col-5">
                  <label className="form-label">Amount</label>
                  <input
                    type="number"
                    className="form-control readonly-input"
                    value={qty && rate ? (qty * rate).toFixed(2) : ""}
                    readOnly
                  />
                </div>
              </div>
              <div className="col-12 d-flex justify-content-center">
                <Button
                  variant="success"
                  className="btn btn-success text-center mt-2"
                  onClick={handleAddItem}
                >
                  Add Item
                </Button>
              </div>
              {showTable && orderItems.length > 0 && (
                <>
                  <div className="mt-4 table-container">
                    <div className="bill-header d-md-flex d-lg-flex d-block justify-content-md-between  justify-content-lg-between mb-2">
                      {/* <h6>Bill No: {billNo}</h6> */}
                      <h6>Total Amount: ₹ {totalAmount.toFixed(2)}</h6>
                    </div>

                    <div className="table-responsive1">
                      <table className="table table-bordered text-center">
                        <thead className="sticky-header">
                          <tr>
                            <th className="text-white">Sr No</th>
                            <th className="text-white">Item Name</th>
                            <th className="text-white">No of Pcs</th>
                            <th className="text-white">Qty</th>
                            <th className="text-white">Rate</th>
                            <th className="text-white">Amount</th>
                          </tr>
                        </thead>

                        <tbody>
                          {orderItems.map((item, index) => (
                            <tr
                              key={item.itemcode}
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                if (e.target.closest(".long-text")) return;
                                setSelectedDeleteItem(item);
                                setShowDeleteModal(true);
                              }}
                            >
                              <td>{index + 1}</td>
                              <td>
                                {" "}
                                <ExpandableTextMobile
                                  text={`${item.itemname}`}
                                  className="long-text"
                                />
                              </td>
                              <td className="no-wrap">{item.noofitem}</td>
                              <td className="no-wrap">{item.qty}</td>
                              <td className="no-wrap">
                                {item.rate.toFixed(2)}
                              </td>
                              <td className="no-wrap">
                                {item.amount.toFixed(2)}
                              </td>
                            </tr>
                          ))}
                        </tbody>

                        <tfoot className="sticky-footer">
                          <tr>
                            <th colSpan="1" className="text-center text-white">
                              Total
                            </th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th className="text-white">
                              <ExpandableTextMobile
                                text={`${totalAmount.toFixed(2)}`}
                                className="long-text"
                              />
                            </th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  <div className="mb-1 ">
                    <label className="label mb-1">Remark</label>
                    <input
                      type="text"
                      className="  form-control"
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                    />
                  </div>
                </>
              )}
            </div>
          </Modal.Body>
          {showTable && orderItems.length > 0 && (
            <Modal.Footer>
              <Button
                variant="danger"
                onClick={() => {
                  setCancelConfimationModal(true);
                }}
                className="no-btn"
              >
                Cancel
              </Button>
              <Button
                variant="success"
                className="btn btn-success  "
                onClick={() => setShowConfimationModal(true)}
              >
                Submit
              </Button>
            </Modal.Footer>
          )}
        </div>
      </Modal>
      <Modal
        show={showItemModal}
        onHide={() => {
          setShowItemModal(false);
          setSearchText("");
        }}
        size="lg"
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">Select Item</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="mb-3 position-relative">
              <input
                type="text"
                className="form-control pe-5"
                placeholder="Search item..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                ref={itemSearchRef}
              />

              {searchText && (
                <span
                  onClick={() => setSearchText("")}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#888",
                  }}
                >
                  ✕
                </span>
              )}
            </div>

            <div className="row">
              {filteredItems.map((item, index) => {
                const rateData = getItemRateData(item);

                return (
                  <div key={index} className="col-6 col-md-4 mb-3">
                    <div
                      className="item-card"
                      onClick={() => {
                        setSelectedItem(item);
                        setRate(rateData.rate);
                        setRateMeta(rateData);
                        setShowItemModal(false);
                        setSearchText("");
                      }}
                    >
                      <h6>{item.name}</h6>
                      <img
                        src={item.itemimage}
                        alt=""
                        className="item-img"
                        style={{ objectFit: "contain" }}
                      />
                      <div>
                        Rate/
                        {item?.unit === "K"
                          ? "Kg"
                          : item?.unit === "P"
                            ? "Pcs"
                            : item?.unit === "L"
                              ? "Ltr"
                              : ""}{" "}
                        : {rateData.rate} Rs
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Modal.Body>
        </div>
      </Modal>

      <Modal
        show={showConfirmationModal}
        onHide={() => setShowConfimationModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">Confirmation Alert</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to submit order?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              onClick={() => {
                setShowConfimationModal(false);
                setShowDeliveryTypeModal(true);
              }}
              className="btn btn-success"
            >
              Yes
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">Confirm Delete</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {selectedDeleteItem && (
              <p>
                Are you sure you want to delete item{" "}
                <strong>{selectedDeleteItem.itemname}</strong> ?
              </p>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="danger"
              onClick={() => {
                handleDeleteItem();
              }}
            >
              Yes, Delete
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        show={cancelConfirmationModal}
        onHide={() => setCancelConfimationModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">Confirmation Alert</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Are you sure you want to cancel order?</p>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="success"
              onClick={() => {
                setCreateOrderModal(false);
                navigate("/dashboard");
                resetCreateOrder();
              }}
              className="btn btn-success"
            >
              Yes
            </Button>
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        show={showDeliveryTypeModal}
        onHide={() => setShowDeliveryTypeModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <div className="bg-Modal-black">
          <Modal.Header closeButton>
            <Modal.Title className="text-theme">
              Select Delivery Type
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p className="mb-3">Are you sure you want to submit order?</p>

            <div className="d-flex flex-column gap-2">
              {/* Pickup */}
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  id="pickup"
                  name="deliveryType"
                  value="S"
                  checked={deliveryType === "S"}
                  onChange={(e) => setDeliveryType(e.target.value)}
                />
                <label className="form-check-label" htmlFor="pickup">
                  Pick up from Store
                </label>
              </div>

              {/* Home Delivery */}
              <div className="form-check">
                <input
                  type="radio"
                  className="form-check-input"
                  id="home"
                  name="deliveryType"
                  value="H"
                  checked={deliveryType === "H"}
                  onChange={(e) => setDeliveryType(e.target.value)}
                />
                <label className="form-check-label" htmlFor="home">
                  Home Delivery
                </label>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <ButtonSpinner
              variant="success"
              className="btn btn-success"
              loading={addLoading}
              onClick={() => {
                if (deliveryType === "H") {
                  setShowDeliveryTypeModal(false);
                  navigate("/address_list", {
                    state: { finalData: finalData },
                  });
                } else {
                  navigate("/new_order");
                  handleCreateOrder();
                }
              }}
            >
              <b>{addLoading ? "Adding Order..." : "Add"}</b>
            </ButtonSpinner>
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

export default NewOrder;
